import React from 'react';

import type { ModalBaseValue } from './RCModalBase';

export const PartsContext = React.createContext<ModalBaseValue | null>(null);

export function usePartsContext(part: string) {
  const value = React.useContext(PartsContext);
  if (!value) throw new Error(`RCModalBase.${part} must be rendered inside RCModalBase.Root.`);
  return value;
}
